import ResultPage from '@/components/Result/index'

const ShareDataSuccessPage = () => {
	const breadcrumbItem = [
		{
			label: '',
			link: `/`,
		},
		{
			label: 'Shared Data',
			link: `/shared-data`
		},
		{
			label: 'Share Data',
			link: `/shared-data/share`
		},
		{
			label: 'Success',
			link: `/shared-data/share/success`
		}
	]

	return ResultPage({
		defaultTitle: "shareData",
		layoutHeaderTxt: "dataFileShared",
		layoutSubHeaderTxt: "dataFileSharedMessage",
		backBtnTxt: "backToSharedData",
		breadcrumbs: breadcrumbItem,
		nextLocation: '/shared-data',
	});
}
export default ShareDataSuccessPage
